export const data = {
    productItems: [
        {
            id:1,
            name: "Burger",
            price: 3,
            image: "../Images/burger.png",
            quantity: 0,
            info: {
                calories: 850,
                ingredients: "Beef, Cheese, Tomato, Onion, Ketchup, Mayonaise"
            }
        },
        {
            id:2,
            name: "Cheese",
            price: 1.5,
            image: "../Images/cheese.png",
            quantity: 0,
            info: {
                calories: 1000,
                ingredients: "Cheese"
            }
        },
        {
            id:3,
            name: "Chicken-Nugget",
            price: 2,
            image: "../Images/chicken-nugget.png",
            quantity: 0,
            info: {
                calories: 600,
                ingredients: "White Chicken Meat"
            }
        },
        {
            id:4,
            name: "Coca-Cola",
            price: 1,
            image: "../Images/cola.png",
            quantity: 0,
            info: {
                calories: 150,
                ingredients: "Carbonated Water, Sugar, Natural Caramel Color, Acidity Regulators, Kola Concentrate, Caffeine"
            }
        },
        {
            id:5,
            name: "Hot-Dog",
            price: 1.8,
            image: "../Images/hotdog.png",
            quantity: 0,
            info: {
                calories: 500,
                ingredients: "Sausage, Cheese, Ketchup, Mustard, Toppings"
            }
        },
        {
            id:6,
            name: "Juice",
            price: 1.2,
            image: "../Images/juice.png",
            quantity: 0,
            info: {
                calories: 100,
                ingredients: "Orange"
            }
        },
        {
            id:7,
            name: "Pizza",
            price: 5,
            image: "../Images/pizza.png",
            quantity: 0,
            info: {
                calories: 1200,
                ingredients: "Sauce, Cheese, Tomato, Olives, Pepperoni"
            }
        },
        {
            id:8,
            name: "Popcorn",
            price: 4,
            image: "../Images/popcorn.png",
            quantity: 0,
            info: {
                calories: 200,
                ingredients: "Corn"
            }
        },
        {
            id:9,
            name: "Sushi",
            price: 8,
            image: "../Images/sushi.png",
            quantity: 0,
            info: {
                calories: 600,
                ingredients: "Salmon, Rice, Dried seaweed"
            }
        }
    ]
}